export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Analyser le dossier"])}
      },
      "en": {
        "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Review the claim"])}
      }
    }
  })
}
